import axios from "../axios";

const api = {
  createDirectEmissions({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/direct-emissions`, data, headers)
      .then(({ data }) => data);
  },

  addDirectEmissionsItem({ questionnaireId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/direct-emissions/${type}`, data, headers)
      .then(({ data }) => data);
  },

  updateDirectEmissionsItem({ questionnaireId, recordId, data, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/direct-emissions/${type}/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  updateDirectEmissions({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/direct-emissions/${id}`, data, headers)
      .then(({ data }) => data);
  },

  deleteItem({ questionnaireId, recordId, type }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/direct-emissions/${type}/${recordId}`,
      headers).then(({ data }) => data);
  },

  getDirectEmissionsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/direct-emissions/${params.type}`,
      config).then(({ data }) => data);
  },
};

export default api;
